import React, { createContext, useContext, useState, useCallback } from 'react';

const MaintenanceContext = createContext();

export const useMaintenance = () => {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error('useMaintenance must be used within a MaintenanceProvider');
  }
  return context;
};

export const MaintenanceProvider = ({ children }) => {
  const [isInMaintenance, setIsInMaintenance] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState('');

  const activateMaintenance = useCallback((message = '') => {
    setIsInMaintenance(true);
    setMaintenanceMessage(message || 'Le site est actuellement en maintenance. Veuillez réessayer plus tard.');
  }, []);

  const deactivateMaintenance = useCallback(() => {
    setIsInMaintenance(false);
    setMaintenanceMessage('');
  }, []);

  const value = {
    isInMaintenance,
    maintenanceMessage,
    activateMaintenance,
    deactivateMaintenance,
  };

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  );
};

let maintenanceCallback = null;

export const setMaintenanceCallback = (callback) => {
  maintenanceCallback = callback;
};

export const triggerMaintenance = (message) => {
  if (maintenanceCallback) {
    maintenanceCallback(message);
  }
};
